'use client';

import React from 'react';
import styles from './ErrorBoundaryClass.module.scss';
import classnames from 'classnames';
import { useTranslations } from 'next-intl';
import { useEnvContext } from '@/context/envContext';
class ErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    // Define a state variable to track whether is an error or not
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI
    return {
      hasError: true
    };
  }
  componentDidCatch(error: any, errorInfo: any) {
    // You can use your own error logging service here
    console.table({
      error,
      errorInfo
    });
    console.groupEnd();
  }
  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      return <ErrorFallback data-sentry-element="ErrorFallback" data-sentry-component="ErrorBoundary" data-sentry-source-file="ErrorBoundaryClass.tsx" />;
    }
    return this.props.children;
  }
}
const ErrorFallback = () => {
  const t = useTranslations('Errors');
  const {
    cdnEnv
  } = useEnvContext();

  // If cdnEnv is undefined use prods hardcoded url path
  const borderFlash = cdnEnv ? `${cdnEnv}/rms/images/border_diagonal.svg` : 'https://media.techtarget.com/rms/images/border_diagonal.svg';

  // You can render any custom fallback UI
  return <div className={classnames('container', styles['box'])} data-sentry-component="ErrorFallback" data-sentry-source-file="ErrorBoundaryClass.tsx">
      <div className={'row'}>
        <h1 className={'section-heading'}>{t('MainTitle')}</h1>
        <div>
          <div aria-hidden="true" style={{
          backgroundImage: `url(${borderFlash})`,
          backgroundRepeat: 'repeat-x',
          width: '100%',
          height: '10px',
          marginBottom: '20px'
        }}></div>
        </div>
        <p>
          {t('MainText')}
        </p>

        <button className={classnames('tt-button-med', styles['errorboundary-btn'])} type="button" onClick={() => {
        history.back();
      }}>
          {t('Button')}
        </button>
      </div>
    </div>;
};
export default ErrorBoundary;